var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"return-home"},[_c('a',{on:{"click":_vm.linkFunClick}},[_c('i')])])}
var staticRenderFns = []
export { render, staticRenderFns }